export const eventTypes = [
  ['craft_day', 'Craft Day'],
  ['recruiting_night', 'Recruiting Night'],
  ['brunch', 'Brunch'],
  ['thrift_crawl', 'Thrift Crawl'],
  ['in_town_faire', 'In-Town Faire'],
  ['out_of_town_faire', 'Out-Of-Town Faire'],
  ['meeting', 'Meeting'],
  ['gathering', 'Gathering'],
  ['community_event', 'Community Event'],
  ['other', 'Other'],
] as const

export function isFaireEvent(type:string|undefined){
  return type==='faire'||type==='in_town_faire'||type==='out_of_town_faire'
}

export function eventTypeLabel(type:string){
  return eventTypes.find(([value])=>value===type)?.[1]||(type==='faire'?'Faire':type.replaceAll('_',' '))
}
